(function () {
    'use strict';

    angular
        .module('recomActionPlanUpdateStatusAssessControllers')
        .controller('RecomUpdateStatusAssessCriteriasToReviewByQuarterController', Controller);

    Controller.$inject = ['$scope', '$timeout', '$state', '$stateParams', '$mdToast', 'recomActionPlanUpdateStatusService', 'govNotificationDelay'];

    function Controller($scope, $timeout, $state, $stateParams, $mdToast, recomActionPlanUpdateStatusService, govNotificationDelay) {

        // TODO: Use new data to check next/prev pages
        // Group by quarter
        $scope.ctrlCtxt.activeIndex = _.indexOf($scope.fiscalYearQuarterKeys, $stateParams.FiscalYearQuarterKey);
        $scope.ctrlCtxt.isNextInitiative = false;
        $scope.ctrlCtxt.activeQuarter = $stateParams.FiscalYearQuarterKey;
        $scope.ctrlCtxt.activeFiscalYear = $scope.criteriaAssessmentsByQuarter[0].ActionPlanCriteria.TargetFiscalYear;
        $scope.ctrlCtxt.activeQuarterTitle = $scope.criteriaAssessmentsByQuarter[0].ActionPlanCriteria.TargetDateQuarterShortTitleEN;
        $scope.ctrlCtxt.nextQuarter = null;
        $scope.ctrlCtxt.prevQuarter = null;

        $scope.ctrlCtxt.startForwardFlip = $stateParams.toNext !== false;
        $scope.ctrlCtxt.startBackwardFlip = $stateParams.toPrevious;
        $scope.ctrlCtxt.readyForAnimation = true;
        $scope.ctrlCtxt.hideContent = false;
        $scope.ctrlCtxt.moveForward = null;

        $scope.ctrlCtxt.initPlanQuarters = function () {
            if ($scope.fiscalYearQuarterKeys.length > 1
                && $scope.ctrlCtxt.activeIndex + 1 < $scope.fiscalYearQuarterKeys.length) {
                $scope.ctrlCtxt.nextQuarter = $scope.fiscalYearQuarterKeys[$scope.ctrlCtxt.activeIndex + 1];
            } else {
                $scope.ctrlCtxt.isNextInitiative = true;
            }

            if ($scope.ctrlCtxt.activeIndex > 0) {
                $scope.ctrlCtxt.prevQuarter = $scope.fiscalYearQuarterKeys[$scope.ctrlCtxt.activeIndex - 1];
            }
        };

        // Go to Previous Criterias Quarter
        $scope.goToPrevCriteriasQuarter = function () {
            $scope.ctrlCtxt.moveBackwards = true;
            $scope.ctrlCtxt.hideContent = true;
            $timeout(function () {
                $state.go('recomActionPlanUpdateStatusReview.actionPlans.byActionPlanCriteriasByQuarter', {
                    FiscalYearQuarterKey: $scope.ctrlCtxt.prevQuarter,
                    toPrevious: true,
                    toNext: false
                });
            }, 150);
        };

        // Go to Next Criterias Quarter
        $scope.goToNextCriteriasQuarter = function () {
            $scope.ctrlCtxt.moveForward = true;
            $scope.ctrlCtxt.hideContent = true;

            $timeout(function () {
                $state.go('recomActionPlanUpdateStatusReview.actionPlans.byActionPlanCriteriasByQuarter', {
                    FiscalYearQuarterKey: $scope.ctrlCtxt.nextQuarter,
                    toNext: true,
                    toPrevious: false
                });
            }, 150);
        };

        // To Go Action Plan
        $scope.goToActionPlan = function () {
            if ($scope.assessmentsByActionPlan.ActionPlanAssessment.AreAllCriteriasReviewed ) {
                $scope.ctrlCtxt.moveForward = true;
                $scope.ctrlCtxt.hideContent = true;
                $timeout(function () {
                    $state.go('recomActionPlanUpdateStatusReview.actionPlans.byActionPlanAssessment', {
                        ActionPlanID: $scope.actionPlan.ActionPlanID
                    });
                }, 150);

                return;
            }

            if (!$scope.isMissingAssessmentsShow) {
                $scope.isMissingAssessmentsShow = true;
                $timeout(function () {
                    $scope.isMissingAssessmentsShow = false;
                }, govNotificationDelay);
            }
        };

        // Unlock Action Plan
        $scope.unlockActionPlan = function () {
            if (!$scope.assessmentsByActionPlan.ActionPlanAssessment.IsLocked) return;

            $scope.ctrlCtxt.isLoading = true;

            recomActionPlanUpdateStatusService
                .unlockActionPlanAssessment(
                    $scope.actionPlan.RecomBusinessUnitID,
                    $scope.actionPlan.ActionPlanID,
                    $scope.assessmentsByActionPlan.ActionPlanAssessment)
                .then(function () {

                    $mdToast.show(
                        $mdToast
                            .simple()
                            .content('Action plan has been unlocked')
                            .position('top right')
                            .hideDelay($scope.govNotificationDelay)
                            .action('OK')
                            .theme('primary')
                    );

                    $state.reload();
                })
                .finally(function () {
                    $scope.ctrlCtxt.isLoading = false;
                });
        };

        // Lock Action Plan
        $scope.lockActionPlan = function () {
            $scope.ctrlCtxt.isLoading = true;

            recomActionPlanUpdateStatusService
                .lockActionPlanAssessment($scope.actionPlan.RecomBusinessUnitID,
                                          $scope.actionPlan.ActionPlanID,
                                          $scope.assessmentsByActionPlan.ActionPlanAssessment)
                .then(function () {
                    $state.reload();
                });
        };
    }
})();